import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AiUploadBatchObjectsService } from '../../../services/ai-upload-batch-objects.service';
import { ToastrService } from 'ngx-toastr';
import { AiUploadBatchObjectCounts, BatchUploadObject, BatchUploadPageInfo, CategoryType } from '../../../models/ai-upload-batch-object.model';

@Component({
  selector: 'lib-ai-segmentation-list',
  templateUrl: './ai-segmentation-list.component.html',
  styleUrls: ['./ai-segmentation-list.component.scss'],
  standalone: false,
})
export class AiSegmentationListComponent implements OnInit {

  constructor(
    private router: Router,
    private aiUploadBatchObjectsService: AiUploadBatchObjectsService,
    private toastr: ToastrService,
  ) {}

  mvPoles: any[] = [];
  count: number = 1;
  currentPage: number = 1;
  objectCategoryName = "AI.OBJECT_CATEGORY"
  dropdownOpened: boolean = false;
  categoryTypeValue: CategoryType = CategoryType.ALL;
  categoryTypeOptions = CategoryType;
  mapObjectCategory: Record<number, string> = {
    [CategoryType.ALL]: 'AI.SEGMENTATION_LIST.ALL',
    [CategoryType.BUILDING]: 'AI.SEGMENTATION_LIST.BUILDINGS',
    [CategoryType.LV_POLES]: 'AI.SEGMENTATION_LIST.LV_POLES',
    [CategoryType.MV_POLES]: 'AI.SEGMENTATION_LIST.MV_POLES',
    [CategoryType.HV_POLES]: 'AI.SEGMENTATION_LIST.HV_POLES',
    [CategoryType.DISTRIBUTION_TRANSFORMERS_POLE_MOUNTED]: 'AI.DT_POLE_MOUNTED',
    [CategoryType.DISTRIBUTION_TRANSFORMERS_GROUND_MOUNTED]: 'AI.DT_GROUND_MOUNTED',
    [CategoryType.INJECTION_SUBSTATIONS]: 'AI.SEGMENTATION_LIST.INJECTION_SUBSTATIONS',
    [CategoryType.TRANSMISSION_STATIONS]: 'AI.SEGMENTATION_LIST.TRANSMISSION_STATIONS'
  }

  mapObjectCategoryForTable: Record<number, string> = {
    [CategoryType.BUILDING]: 'AI.SEGMENTATION_LIST.BUILDING',
    [CategoryType.LV_POLES]: 'AI.SEGMENTATION_LIST.LV_POLE',
    [CategoryType.MV_POLES]: 'AI.SEGMENTATION_LIST.MV_POLE',
    [CategoryType.HV_POLES]: 'AI.SEGMENTATION_LIST.HV_POLE',
    [CategoryType.DISTRIBUTION_TRANSFORMERS_POLE_MOUNTED]: 'AI.SEGMENTATION_LIST.DT_POLE_MOUNTED',
    [CategoryType.DISTRIBUTION_TRANSFORMERS_GROUND_MOUNTED]: 'AI.SEGMENTATION_LIST.DT_GROUND_MOUNTED',
    [CategoryType.INJECTION_SUBSTATIONS]: 'AI.SEGMENTATION_LIST.INJECTION_SUBSTATION',
    [CategoryType.TRANSMISSION_STATIONS]: 'AI.SEGMENTATION_LIST.TRANSMISSION_STATION'
  }

  batchUploadPageInfo!: BatchUploadPageInfo;
  batchUploadObjects: BatchUploadObject[] = [];
  aiUploadBatchObject!: AiUploadBatchObjectCounts;


  isImageModalOpen = false;
  selectedImageUrl: string | null = null;
  selectedObjectUrl: string | null = null;
  generatedObjectModalOpened!: boolean;


  closeGeneratedModal(){
    this.generatedObjectModalOpened = false;
  }

  openModal(generatedObjectUrl: string){
    if(generatedObjectUrl == '/'){
      this.toastr.warning('No generated object available for this asset.');
      return;
    }
    this.selectedObjectUrl = generatedObjectUrl;
    this.generatedObjectModalOpened = true;
  }

closeImageModal() {
  this.isImageModalOpen = false;
  this.selectedImageUrl = null;
}


  ngOnInit(): void { 
    this.reloadTable();
  }


   toggleDropdown() {
    this.dropdownOpened = !this.dropdownOpened;
  }


  onRowClick(mvPoleId: string) {
     //this.router.navigate(['ai/segmentation-list/edit', mvPoleId]);
  }
  onPageChange(currentPage: number) {
    this.currentPage = currentPage;
    this.reloadTable(currentPage);
  }

  reloadTable(page: number | null = null) {
    if(page){
      this.currentPage = page;
    }
    this.getAll();
    this.getAnalytics();
  }

  selectObjectCategoryOption(option: CategoryType) {
    this.categoryTypeValue = option;
    this.objectCategoryName = this.mapObjectCategory[option];
    this.dropdownOpened = false;
    this.reloadTable();
  }


  mapObjectCategoryValue(option: number){
    return this.mapObjectCategoryForTable[option];
  }

  onImageClick(item: string) {
    if(item == '/'){
      this.toastr.warning('No image available for this asset.');
      return;
    }
    this.selectedImageUrl = item;
    this.isImageModalOpen = true;
  }


  getAll(){
    this.batchUploadPageInfo = {
        pageInfo: {
            pageSize: 10,
            page: this.currentPage,
        },
        filterParams: {
            category: this.categoryTypeValue === CategoryType.ALL ? null : this.categoryTypeValue
        }
    };
    this.aiUploadBatchObjectsService.getall(this.batchUploadPageInfo).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 'OK') {
          this.count = responseData.data.count ?? this.count;
          this.batchUploadObjects = responseData.data.data;
          this.batchUploadObjects.forEach(obj => {
            if (obj.imageId !== '/') {
              try {
                const imageArray = JSON.parse(obj.imageId);
                if (Array.isArray(imageArray) && imageArray.length > 0) {
                  obj.imageId = imageArray[0];
                }
              } catch (error) {
                console.error('Greška pri parsiranju imageId za objekat:', obj, error);
              }
            }
          });

          if (responseData.message !== '') {
            this.toastr.warning(responseData.message);
          }
        } else {
          this.toastr.error(responseData?.message || 'Failed to fetch segmentation list data');
        }
      }
    });
  }

  private getAnalytics() {
      this.aiUploadBatchObjectsService.getSegmentationData().subscribe({
        next: (response: any) => {
          const responseData = response.body;
          if (responseData?.status === 'OK') {
            this.aiUploadBatchObject = new AiUploadBatchObjectCounts(responseData.data.categoryCounts);
            this.getTotalSegmentedObjectCount();
            if (responseData.message !== '') {
              this.toastr.warning(responseData.message);
            }
          } else {
            this.toastr.error(responseData?.message || 'Failed to fetch segmentation data');
          }
        },
        error: (error) => {
          this.toastr.error('An error occurred while fetching segmentation data');
        }
      });
    }

    private getTotalSegmentedObjectCount() {
    if (this.aiUploadBatchObject) {
      this.aiUploadBatchObject.totalSegmentedObjectsCount = 
        this.aiUploadBatchObject.buildingsCount +
        this.aiUploadBatchObject.lvPolesCount +
        this.aiUploadBatchObject.dtPoleMountedCount +
        this.aiUploadBatchObject.dtGroundMountedCount +
        this.aiUploadBatchObject.mvPolesCount +
        this.aiUploadBatchObject.injectionSubstations +
        this.aiUploadBatchObject.hvPolesCount +
        this.aiUploadBatchObject.tsCount;
    }
  }
}
